/**
 * One email a specific institution received. Maps InstitutionEmailMessageResource (PascalCase).
 * Carries this institution's own delivery outcome rather than the message-wide counters — inside a
 * single institution, a broadcast's global "sent/failed" totals say nothing about this recipient.
 */
export default class InstitutionEmailMessage {
  id: number

  subject: string

  htmlBody: string

  scope: number // EmailRecipientScopeEnum: 1=single institution, 2=all approved

  senderEmail: string

  createdAt?: Date

  sentAt?: Date

  attachmentNames: string[]

  recipientEmail: string

  // EmailRecipientStatusEnum: 1=pending, 2=sent, 3=failed
  recipientStatusId: number

  recipientSentAt?: Date

  attempts: number

  errorMessage: string

  constructor(m: any) {
    this.id = m.Id
    this.subject = m.Subject
    this.htmlBody = m.HtmlBody
    this.scope = m.Scope
    this.senderEmail = m.SenderEmail
    this.createdAt = m.CreatedAt ? new Date(m.CreatedAt) : undefined
    this.sentAt = m.SentAt ? new Date(m.SentAt) : undefined
    this.attachmentNames = m.AttachmentNames || []
    this.recipientEmail = m.RecipientEmail || ''
    this.recipientStatusId = m.RecipientStatusId
    this.recipientSentAt = m.RecipientSentAt
      ? new Date(m.RecipientSentAt)
      : undefined
    this.attempts = m.Attempts ?? 0
    this.errorMessage = m.ErrorMessage || ''
  }
}
